import { useParsedQuery } from '@/hooks/useParsedQuery'
import { SlotView } from '@/services/outboundSchedule2/types'
import dayjs from 'dayjs'
import { useCutOffDate } from './useCutOffDate'
import { OutboundSchedulePageQueryParams } from '../types/query'
import { useGetOutboundSchedules } from '@/services/outboundSchedule2/useOutboundScheduleQueries'

export type TimeSlot = { date: string } & SlotView

/**
 * v2 get-schedules-grid 응답의 24h 슬롯을 그리드용 TimeSlot[]으로 반환.
 * '지난 시간대 보기' OFF 시 현재 시(hour) 이전 슬롯은 숨김 (현재 시 슬롯은 강조 대상이라 유지).
 */
export const useGetTimeSlots = (): TimeSlot[] => {
  const { parsedQs } = useParsedQuery<OutboundSchedulePageQueryParams>()
  const showPastCutOff = parsedQs.showPastCutOff === 'true'

  const { cutOffDate, shipperCode } = useCutOffDate()
  const { data } = useGetOutboundSchedules({ date: cutOffDate, shipperCode, cutType: 'B2C' })

  const allTimeSlots: TimeSlot[] = (data?.slots ?? []).map((slot) => ({ date: cutOffDate, ...slot }))

  if (showPastCutOff) return allTimeSlots

  const currentHourStart = dayjs().startOf('hour')
  return allTimeSlots.filter((slot) => !dayjs(`${slot.date} ${slot.startTime}`).isBefore(currentHourStart))
}
